export const NOMAD_LIFE_MERCHANT = '2';

export const nomadLifeVerify = (param?: string) => {
  if (param) {
    return `/${NOMAD_LIFE_MERCHANT}/verify/${param}` as const;
  }
  return 'verify/:id' as const;
};

export const nomadLifeVerifySuccess = (param?: string) => {
  if (param) {
    return `/${NOMAD_LIFE_MERCHANT}/verify/success/${param}` as const;
  }
  return 'verify/success/:id' as const;
};

export const nomadLifeVerifyFailed = (param?: string) => {
  if (param) {
    return `/${NOMAD_LIFE_MERCHANT}/verify/failed/${param}` as const;
  }
  return 'verify/failed/:id' as const;
};

export const nomadLifePay = (param?: string) => {
  if (param) {
    return `/${NOMAD_LIFE_MERCHANT}/pay/${param}`;
  }
  return 'pay/:id' as const;
};

export const nomadLifePaySuccess = (param?: string) => {
  if (param) {
    return `/${NOMAD_LIFE_MERCHANT}/pay/success/${param}` as const;
  }
  return 'pay/success/:id' as const;
};

export const nomadLifePayFailed = (param?: string) => {
  if (param) {
    return `/${NOMAD_LIFE_MERCHANT}/pay/failed/${param}` as const;
  }
  return 'pay/failed/:id' as const;
};
